<ng-container *ngIf="{ productionVersionState: productionVersionState$ | async, sharedDataState: sharedDataState$ | async } as states">

    <div class="production-version-detail-container">

        <div style="display: flex; gap: 5px; align-items: stretch">
            <span>
                <button style="flex-grow: 0;" mat-raised-button (click)="goBack()">
                <mat-icon>arrow_back</mat-icon>
            </button>
            </span>
            <mat-card appearance="outlined" class="header-card">
                <div class="headerInfo">
                    <span><h3> {{ "app.model.production-version.cost-unit.label" | translate }}: </h3></span>
                    <div>
                        <ng-container *ngIf="states.sharedDataState.isLoading; else showCostUnitName">
                            <mat-progress-bar color="accent" mode="indeterminate"></mat-progress-bar>
                        </ng-container>

                        <ng-template #showCostUnitName>
                            <ng-container *ngIf="states.sharedDataState.costUnitLookup[states.productionVersionState.selectedProductionVersion?.costUnitId]; else missingCostUnit">
                                {{ states.sharedDataState.costUnitLookup[states.productionVersionState.selectedProductionVersion.costUnitId].name }}
                            </ng-container>

                            <ng-template #missingCostUnit>-</ng-template>
                        </ng-template>

                        - {{ states.productionVersionState.selectedProductionVersion?.articleNr }}
                    </div>
                </div>
                <span class="headerInfo"><h4>{{ "app.model.production-version.version.label" | translate }}
                    :</h4> {{ states.productionVersionState.selectedProductionVersion?.version }}</span>
                <span class="headerInfo"><h4>{{ "app.model.production-version.workingPlanNr.label" | translate }}
                    :</h4> {{ states.productionVersionState.selectedProductionVersion?.workingPlanNr }}</span>
            </mat-card>
        </div>
        <mat-progress-bar color="accent" *ngIf="states.sharedDataState.isLoading || states.productionVersionState.isLoading" mode="indeterminate"></mat-progress-bar>

        <div class="recipe-tables">
            <div class="recipe-table">
                <h3>
                    {{ "app.page.production-version-detail.recipe-entry.label" | translate }}
                    ({{ "app.page.production-version-detail.recipe-nr.label" | translate }}:
                    {{ states.productionVersionState.selectedProductionVersion?.incomingRecipeNr }})
                </h3>
                <app-recipe-table (onArticleSelected)="navigateToProductionVersion($event)" [recipeArticles]="states.productionVersionState.recipe.entries"></app-recipe-table>
            </div>
            <mat-divider [vertical]="true"></mat-divider>
            <div class="recipe-table">
                <h3>
                    {{ "app.page.production-version-detail.recipe-exit.label" | translate }}
                    ({{ "app.page.production-version-detail.recipe-nr.label" | translate }}:
                    {{ states.productionVersionState.selectedProductionVersion?.outgoingRecipeNr }})
                </h3>
                <app-recipe-table (onArticleSelected)="navigateToProductionVersion($event)" [recipeArticles]="states.productionVersionState.recipe.exits"></app-recipe-table>
            </div>
        </div>

    </div>

</ng-container>
